import React from "react";
import styled from "styled-components";

const Message = styled.p``;
const ErrorMessage = ({ text }: any) => <Message>{text}</Message>;

export default ErrorMessage;
